<template>
	<div>
		<GenericSelector 
			:value="value"
			@input="val => $emit('input', value)"
			:options="options" 
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="loading || loadingOptions"
		>
			<template v-slot:unselectedHeader>
				<div class="clearfix my-2">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" class="float-left" />

					<button 
						type="button" 
						@click="showOptions = !showOptions"
						class="btn float-right" 
						:class="showOptions ? 'btn-secondary' : 'btn-primary'"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: { 
		GenericSelector,
		SearchBar,
	},
    props: {
		value: Array,
		loading: {
			type: Boolean,
			default: false,
		},
	},
    data() {
        return {
            forms: [],
            showOptions: false,
			loadingOptions: true,
			search: '',
        };
    },
    mounted() {
        this.getOptions().then(() => this.loadingOptions = false);
    },
    methods: {
        handleRightClick(id) {
            this.showDeleteButton = id
        },
        getOptions() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/listall`, {
                method: 'POST'
            })
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpecred error fetching forms')
				
				this.forms = res.results
            })
			.catch(error => {
				console.error(error)
                this.$log.error.call(this, error);
            })
        },
    },
    computed: {
		options() {
			return this.forms.filter(form => !this.search || form.title.toLowerCase().includes(this.search.toLowerCase()))
		}
    },
};
</script>
